
import CountingMethod from '../../utils/getCountingMethod'
import moment from 'moment'
import Highcharts from 'highcharts'
import { CurrentEpiWeek } from './../../pages/SeasonalPattern/transformDataForGrid'
const getLineChartOptions = (data) => {
  return{
    title: {
      text: undefined,
    },
  
    xAxis: {
      type: 'datetime',
      accessibility: {
        rangeDescription: 'Date Range',
      },
      labels: {
        formatter: function () {
          return Highcharts.dateFormat('%b %Y', this.value)
        },
      },
      lineColor: '#929496',
      lineWidth: 1, 
    },
    yAxis: {
      title: {
        text: 'Count',
        style: {
          color: Highcharts.getOptions().colors[1],
          fontSize: '14px',
        },
      },
      labels: {
        style: {
          fontSize: '16px',
          fontWeight: '400',
          color: '#4B4D4F',
        },
      },
      gridLineColor: '#CBCCCD',
    },
    tooltip: {
      crosshairs: true,
      shared: true,
      useHTML: true,
      padding: 0,
      formatter: function(){
          let toolTipHTML = ''
          toolTipHTML = `<div style="background-color: #FFFFFF;color:#4B4D4F;  padding: 16px;border: 1px  #CBCCCD;
          border-radius: 4px; ">
 
           <span style="font-family: 'Optum Sans', sans-serif;
           font-style: normal;
           font-weight: 700;
           font-size: 14px;
           line-height: 18px;">
             ${moment(
              this.x
            ).format('MMMM, YYYY')}</span>`
        
          this.points.forEach((point) => {
            let legendSymbol = ''
            if (point.series.legendSymbol !== undefined) {
              let series = point.series
              legendSymbol =
                "<svg width='16' height='16'>" +
                series.legendSymbol.element.outerHTML +
                point.series.legendSymbol.element.previousElementSibling.outerHTML +
                '</svg>'
            }
            
       
              {toolTipHTML += `<h6 style="font-family: 'Optum Sans', sans-serif;
              font-style: normal;
              font-weight: 400;
              font-size: 12px;
              line-height: 16px;"><span style="padding-right:8px;">${legendSymbol}</span>
               <b>${CountingMethod(point.y)} ${point.series.name}</b></h6>`
            }
       
           
          })

        return toolTipHTML
      },
    },
    credits: {
      enabled: false,
    },
    legend: {
      layout: 'horizontal',
      align: 'center',
      verticalAlign: 'bottom',
    },

    series: [
      {
        name: 'UHG Covered Count', 
        data: data[0].data,
        zIndex: 1,
        color: '#15A796', 
        marker: {
          enabled: true,
        
        },
      },
      
      {
        name: 'Scaled Estimate',
        data: data[1].data,
        zIndex: 1,
        color: '#15A796', 
        dashStyle: 'ShortDot',
        marker: {
          enabled: true,
       
        },
      },

    ],
  }
}
export default getLineChartOptions
